import { useTranslation } from 'react-i18next'
import { IS_CHINA } from 'constants/environments'
import { HELP } from 'constants/pageNames'

const useCategories = baseUrl => {
  const { t } = useTranslation(HELP)

  const categories = t('Q&A', { returnObjects: true }).map(
    ({ Category, Name, Abbr, Questions, QuestionsCn, title, description }) => ({
      category: Category,
      name: Name,
      abbr: Abbr || Name,
      url: `${baseUrl || ''}/${Category}`,
      questions: IS_CHINA ? QuestionsCn : Questions,
      title,
      description,
    })
  )

  return categories
}

export default useCategories
